// lh-klaviyo-bis.js — custom BIS modal for quick-add context
// Bypasses Klaviyo onsite.js showModal (crashes on collection pages — no meta.product)
(function () {
  function openLHBISModal(product, variantId) {
    const cfg = window._lhBISConfig?.modal || {};
    const accountId = 'JeWWgF';
    const selectedVariant = product.variants?.find(v => String(v.id) === String(variantId));
    const productTitle = product.title
      || product.variants?.[0]?.name?.split(' - ')[0]
      || product.handle;
    const headline = (cfg.headline || '{product_name}').replace('{product_name}', productTitle);
    const variantTitle = selectedVariant?.title || '';

    const overlay = document.createElement('div');
    overlay.id = 'lh-bis-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:999999;display:flex;align-items:center;justify-content:center;';

    overlay.innerHTML = `
      <div style="background:${cfg.background_color||'#fff'};color:${cfg.text_color||'#222'};padding:32px;max-width:480px;width:90%;position:relative;">
        <button id="lh-bis-close" style="position:absolute;top:16px;right:16px;background:none;border:none;cursor:pointer;color:${cfg.close_button_color||'#ccc'};font-size:20px;" aria-label="Close">&#x2715;</button>
        <h2 style="margin:0 0 8px;font-size:1.1rem;">${headline}</h2>
        ${variantTitle ? `<p style="margin:0 0 16px;font-size:0.9rem;opacity:0.7;">${variantTitle}</p>` : ''}
        <p style="margin:0 0 20px;">${cfg.body_content||'Register to receive a notification when this item comes back in stock.'}</p>
        <div id="lh-bis-success" style="display:none;background:${cfg.success_background_color||'#d3efcd'};color:${cfg.success_text_color||'#1B9500'};padding:12px;margin-bottom:16px;">${cfg.subscription_success_label||"You're in! We'll let you know when it's back."}</div>
        <div id="lh-bis-error" style="display:none;background:${cfg.error_background_color||'#fcd6d7'};color:${cfg.error_text_color||'#C72E2F'};padding:12px;margin-bottom:16px;"></div>
        <form id="lh-bis-form">
          <input type="email" id="lh-bis-email" placeholder="${cfg.email_field_label||'Email'}" required
            style="width:100%;padding:10px;box-sizing:border-box;margin-bottom:12px;border:1px solid #ccc;">
          <button type="submit" style="width:100%;padding:12px;background:${cfg.button_background_color||'#439fdb'};color:${cfg.button_text_color||'#fff'};border:none;cursor:pointer;font-size:1rem;">
            ${cfg.button_label||'Notify me when available'}
          </button>
        </form>
      </div>`;

    document.body.appendChild(overlay);
    document.getElementById('lh-bis-close').addEventListener('click', () => overlay.remove());
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });
    setTimeout(() => document.getElementById('lh-bis-email')?.focus(), 50);

    document.getElementById('lh-bis-form').addEventListener('submit', function (e) {
      e.preventDefault();
      const email = document.getElementById('lh-bis-email').value;
      const errorEl = document.getElementById('lh-bis-error');
      const successEl = document.getElementById('lh-bis-success');
      errorEl.style.display = 'none';

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${accountId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-06-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
            }
          }
        })
      })
        .then(r => {
          if (r.status === 202) {
            document.getElementById('lh-bis-form').style.display = 'none';
            successEl.style.display = 'block';
          } else {
            return r.json().then(data => {
              errorEl.textContent = data?.errors?.[0]?.detail || 'Something went wrong. Please try again.';
              errorEl.style.display = 'block';
            });
          }
        })
        .catch(() => {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.style.display = 'block';
        });
    });
  }

  // Window-level capture — beats Klaviyo's document-level capture handler
  // Scoped to quick-add-modal only; PDP NWA button is unaffected
  window.addEventListener('click', function (e) {
    const bisBtn = e.target.closest('.klaviyo-bis-trigger');
    if (!bisBtn || !bisBtn.closest('quick-add-modal')) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    const ctx = bisBtn.closest('quick-add-modal');
    const variantId = ctx.querySelector('[name="id"]')?.value
                   || ctx.querySelector('[name="view-variant"]')?.value;
    const product = window.ShopifyAnalytics?.meta?.products
      ?.find(p => p.variants?.find(v => String(v.id) === String(variantId)));
    if (!product || !variantId) return;
    openLHBISModal(product, variantId);
  }, true);
})();
